import { useTranslation } from "react-i18next";
import "./CountdownModal.css";
import { useEffect, useRef } from "react";

const CountdownModal = ({ showCountdownModal, setShowCountdownModal }) => {
  const { t } = useTranslation();

  const confirmButtonRef = useRef(null);

  const returnHandler = () => {
    setShowCountdownModal(false);
  };

  useEffect(() => {
    if (!showCountdownModal) return;
    confirmButtonRef.current?.focus();
    const trapTab = (ev) => {
      if (ev.key === "Tab") {
        ev.preventDefault();
        confirmButtonRef.current?.focus();
      }
    };

    document.addEventListener("keydown", trapTab);
    return () => {
      document.removeEventListener("keydown", trapTab);
    };
  }, [showCountdownModal]);

  return (
    <div
      className="modalContainer"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expiry-title"
      aria-describedby="session-expiry-description"
    >
      <div className="modal-main">
        <h2 id="session-expiry-title" className="countdownTitle">
          {" "}
          {t("countdownModal.title")}
        </h2>
        <div className="countdownTextContainer">
          <br></br>
          <p id="session-expiry-description">{t("countdownModal.text")}</p>
          <br></br>
        </div>

        <footer>
          <div className="countdownButtonContainer">
            <button
              ref={confirmButtonRef}
              className="countdownButtonStyle"
              type="button"
              onClick={() => returnHandler()}
            >
              {t("button.confirm")}
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default CountdownModal;
